import { useAuth0 } from '@auth0/auth0-react';
import Button from '@/ui/_lib/Button';
import useAuth from '@/hooks/useAuth';

interface LogoutButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary' | 'ghost';
}

export default function LogoutButton({ className = '', variant = 'ghost' }: LogoutButtonProps) {
  useAuth0();
  const { logOut } = useAuth();

  const handleLogout = () => {
    logOut();
  };

  return (
    <Button
      onClick={handleLogout}
      variant={variant}
      className={`whitespace-nowrap ${className}`}
    >
      Log Out
    </Button>
  );
}